import { type ReactNode } from 'react';

import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import { PopupContextProvider } from '@kc-console/common-ui/singleton';

import { Gnb } from './default-layout/ui/gnb';
import { Lnb } from './default-layout/ui/lnb';
import RouteProgressBar from './RouteProgressBar';

import { ROUTE_PROGRESS_BAR_ID } from '@/shared/config/routeProgress';

interface DefaultLayoutProps {
  children: ReactNode;
}

export default function DefaultLayout({ children }: DefaultLayoutProps) {
  const theme = useTheme();

  return (
    <LayoutContainer id={ROUTE_PROGRESS_BAR_ID}>
      <RouteProgressBar />
      <Gnb />
      <PageContainer>
        <Lnb />
        {/* 본문 영역 popup/dropdown은 GNB(navigationOverlay=1300) 아래인 contentPopup(1295) 계층을 사용한다. */}
        <PopupContextProvider zIndex={theme.zIndex.contentPopup}>
          <MainContainer>{children}</MainContainer>
        </PopupContextProvider>
      </PageContainer>
    </LayoutContainer>
  );
}

const LayoutContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const PageContainer = styled('div')`
  display: flex;
  flex: 1;
  overflow-y: auto;
`;

const MainContainer = styled('main')`
  display: flex;
  flex: 1;
  overflow-x: auto;
`;
